import React, { useState ,useEffect,useCallback} from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
  Paper,
  Card,
  Stack,CardContent,
  FormControl,
  MenuItem,
  Select,
  Button,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,InputLabel, IconButton,
  OutlinedInput,
  TextField,Grid
} from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../../../AuthProvider";
import Swal from "sweetalert2"; 
import axios from "axios";
import { GlobalStyles } from "@mui/system";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import ListSubheader from '@mui/material/ListSubheader';

// import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import dayjs from "dayjs";

const baseUrl=process.env.REACT_APP_API_BASE_URL

const IntermediateSettings = () => {
  const menuItems = ["Class Registration", "TimeTable Schedule","Receipt Prefix","Coming Soon"];
  const [selectedMenu, setSelectedMenu] = useState("Class Registration");

  //Class And section states
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSections, setSelectedSections] = useState([]);

  //subject states
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [customSubject, setCustomSubject] = useState("");

  //Examtype state
  const [selectedExamType, setSelectedExamType] = useState([]);
  const [customExamType, setCustomExamType] = useState("");


  const [loading, setLoading] = useState(false);


  const { userId, oId,pId } = useAuth();
  const selectedUsers = null; // fallback, update as needed
  const UserId = userId || selectedUsers;

  const [tableLoading, settableLoading] = useState(true);
   const [scheduledPeriodsLoading, setScheduledPeriodsLoading] = useState(true); 

  const [tableData, setTableData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isTimetableEditModalOpen, setIsTimetableEditModalOpen] = useState(false);

const [editCourse, setEditCourse] = useState("");
const [editClass, setEditClass] = useState("");
const [editSections, setEditSections] = useState([]);
// const [editSubjects, setEditSubjects] = useState([]);
// const [editExamType, setEditExamType] = useState("");
const [isUpdating, setIsUpdating] = useState(false);



const [periodNumber, setPeriodNumber] = useState("");
const [startTime, setStartTime] = useState("");
const [endTime, setEndTime] = useState("");
const [type, setType] = useState("");
const [timetableData, setTimetableData] = useState([]);


const [editPeriodNumber, setEditPeriodNumber] = useState("");
const [editStartTime, setEditStartTime] = useState("");
const [editEndTime, setEditEndTime] = useState("");
const [editType, setEditType] = useState("");

// EDIT DIALOG STATES Set comma-separated string from existing data
const [rowSectionsInput, setRowSectionsInput] = useState('');
const [editSubjectsInput, setEditSubjectsInput] = useState('');
const [editExamTypeInput, setEditExamTypeInput] = useState('');

const [rowSections, setRowSections] = useState([]);
const [editSubjects, setEditSubjects] = useState([]);
const [editExamType, setEditExamType] = useState([]);


///prefixand sequence number settings code
 const [receiptPrefix, setPrefix] = useState("");
  const [startSequence, setSequence] = useState("");
  const [rolePayment, setfeeType] = useState("");
   const [prefixloading, setPrefixLoading] = useState(false);

const handleSubmit = async () => {
  if (!receiptPrefix) {
    toast.error("Please enter Prefix", { autoClose: 2000 });
    return;
  }
  if (!startSequence) {
    toast.error("Please enter Start Sequence", { autoClose: 2000 });
    return;
  }
  if (!rolePayment) {
    toast.error("Please select Category Type", { autoClose: 2000 });
    return;
  }

  setPrefixLoading(true);

  try {
    const queryParams = new URLSearchParams({
      receiptPrefix,
      startSequence,
      rolePayment,
    });

    const response = await fetch(
      `${baseUrl}/api/principal/setReceiptPrefix/${pId}?${queryParams.toString()}`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const contentType = response.headers.get("Content-Type");

    let message = "Prefix Updated successfully!";
    if (response.ok) {
      if (contentType && contentType.includes("application/json")) {
        const data = await response.json();
        message = data?.message || message;
      } else {
        message = await response.text();
      }
      toast.success(message, { autoClose: 1000 });
    } else {
      const errorMsg = await response.text();
      throw new Error(errorMsg || `Failed with status: ${response.status}`);
    }
  } catch (error) {
    console.error("Error submitting form:", error);
    toast.error(error.message || "Failed to update!", { autoClose: 2000 });
  } finally {
    setPrefixLoading(false);
  }
};




// // Hall Ticket Prefix Setting code
//  const [prefix, setHallTicketPrefix] = useState("");
//   const [hallticketprefixloading, sethallticketprefixLoading] = useState(false);
//    const [generating, setGenerating] = useState(false);
//   const [deleting, setDeleting] = useState(false);

// // Helper: generate dummy preview
// const preview = prefix ? `${prefix}01101` : "HALTC01101"; // Example

//   /* PATCH with prefix in query param */
//   const handleHallTicketPrefixSubmit = async () => {
//     if (!prefix.trim()) {
//       toast.error("Please enter prefix", { autoClose: 2000 });
//       return;
//     }

//     setLoading(true);
//     try {
//       const query = new URLSearchParams({ prefix }).toString();
//       const res = await fetch(
//         `${baseUrl}/api/principal/setHallTicketPrefix/${pId}?${query}`,
//         { method: "PATCH" }
//       );

//       if (!res.ok) {
//         const msg = await res.text();
//         throw new Error(msg || `Status ${res.status}`);
//       }

//       const msg =
//         (await res.text()) || "Hall-ticket prefix updated successfully!";
//       toast.success(msg, { autoClose: 1000 });
//     } catch (err) {
//       console.error(err);
//       toast.error(err.message || "Update failed", { autoClose: 2000 });
//     } finally {
//       setLoading(false);
//     }
//   };

// /* ---------- PATCH: GENERATE hall-ticket numbers ---------- */
// const generateHallTickets = async () => {
//   setGenerating(true);
//   try {
//     const res = await fetch(
//       `${baseUrl}/api/principal/setAllStudentsHallTickets/${oId}/${pId}`,
//       {
//         method: "PATCH", // changed from POST to PATCH
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({ action: "generateAll" }), // optional payload if needed
//       }
//     );

//     if (!res.ok) throw new Error(await res.text());

//     const msg = (await res.text()) || "Hall-tickets generated!";
//     toast.success(msg, { autoClose: 1000 });
//   } catch (err) {
//     toast.error(err.message || "Generation failed", { autoClose: 2000 });
//   } finally {
//     setGenerating(false);
//   }
// };



// //HALLTICKET DELETE
//   /* ---------- DELETE: remove hall-ticket numbers ---------- */
//   const deleteHallTickets = async () => {
//     setDeleting(true);
//     try {
//       const res = await fetch(
//         `${baseUrl}/api/principal/deleteAllStudentsHallTickets/${oId}/${pId}`,
//         { method: "DELETE" }
//       );

//       if (!res.ok) throw new Error(await res.text());

//       const msg = (await res.text()) || "Hall-tickets deleted!";
//       toast.success(msg, { autoClose: 1000 });
//     } catch (err) {
//       toast.error(err.message || "Deletion failed", { autoClose: 2000 });
//     } finally {
//       setDeleting(false);
//     }
//   };







useEffect(() => {
  if (selectedRow) {
    const safeSplit = (str) =>
      str
        ?.replace(/([a-z])([A-Z])/g, '$1,$2') // Optional: fix malformed strings
        .split(',')
        .map((item) => item.trim())
        .filter((item) => item !== '');

    const classSections = selectedRow.classSectionLimit || '';
    const subjects = selectedRow.allSubject || '';
    const examTypes = selectedRow.examTypes || '';

    setRowSections(safeSplit(classSections));
    setEditSubjects(safeSplit(subjects));
    setEditExamType(safeSplit(examTypes));

    setRowSectionsInput(classSections);
    setEditSubjectsInput(subjects);
    setEditExamTypeInput(examTypes);
  }
}, [selectedRow]);

const handleInputChange = (setter) => (e) => {
  setter(e.target.value);
};



// useEffect(() => {
//   if (selectedMenu === "Class Registration") {
//     fetchTableData();
//   }
// }, [selectedMenu, oId, baseUrl]);

useEffect(() => {
  if (!oId) return; // Ensure oId is present

  if (selectedMenu === "Class Registration") {
    fetchTableData();
  } else if (selectedMenu === "TimeTable Schedule") {
    fetchScheduledPeriods();
  } else {
    setTableData([]); // Optional: clear table if menu doesn't match
  }
}, [oId, selectedMenu]);
  
  
const headerStyle = {
  borderRight: "1px solid #ddd",
  padding: "6px",
  textAlign: "center",
  fontWeight: "bold",
  backgroundColor: "#fff9c4",
};
const cellStyle = { 
  borderRight: "1px solid #ddd",
   padding: "6px", 
   textAlign: "center" 
  };



  
  const classOptions = [
    "Inter-1st-Year",
    "Inter-2nd-Year",
    
  ];
  
  const [sectionOptions, setSectionOptions] = useState(["Section-A", "Section-B", "Section-C"]);



  const [courseOptions, setCourseOptions] = useState(["MPC", "BIPC", "MEC", "CEC", "HEC"]);
const [selectedCourse, setSelectedCourse] = useState("");
const [customCourse, setCustomCourse] = useState("");

const [subjectMap, setSubjectMap] = useState({
  MPC: ["ENGLISH", "TELUGU", "MATHEMATICS-A", "MATHEMATICS-B", "PHYSICS", "CHEMISTRY"],
  BIPC: ["ENGLISH", "TELUGU", "BOTANY", "ZOOLOGY", "PHYSICS", "CHEMISTRY"],
  MEC: ["ENGLISH", "TELUGU", "MATHEMATICS", "ECONOMICS", "COMMERCE"],
  CEC: ["ENGLISH", "TELUGU", "CIVICS", "ECONOMICS", "COMMERCE"],
  HEC: ["ENGLISH", "TELUGU", "HISTORY", "ECONOMICS", "CIVICS"],
});


// const [selectedSubjects, setSelectedSubjects] = useState([]);
// const [customSubject, setCustomSubject] = useState("");

// Add new course
const handleAddCourse = () => {
  const trimmed = customCourse.trim();
  if (trimmed && !courseOptions.includes(trimmed)) {
    setCourseOptions(prev => [...prev, trimmed]);
    setSubjectMap(prev => ({ ...prev, [trimmed]: [] }));
    setSelectedCourse(trimmed);
  }
  setCustomCourse("");
};

// Remove a course
const handleRemoveCourse = (course) => {
  setCourseOptions(prev => prev.filter(c => c !== course));
  setSubjectMap(prev => {
    const copy = { ...prev };
    delete copy[course];
    return copy;
  });
  if (selectedCourse === course) {
    setSelectedCourse("");
    setSelectedSubjects([]);
  }
};

// Add new subject to current course
const handleAddSubject = () => {
  const trimmed = customSubject.trim().toUpperCase(); // convert to uppercase
  if (
    selectedCourse &&
    trimmed &&
    !subjectMap[selectedCourse]?.some((s) => s.toUpperCase() === trimmed)
  ) {
    setSubjectMap(prev => ({
      ...prev,
      [selectedCourse]: [...(prev[selectedCourse] || []), trimmed],
    }));
    setSelectedSubjects(prev => [...prev, trimmed]);
  }
  setCustomSubject("");
};


const handleSelectAll = () => {
  const allSubjects = subjectMap[selectedCourse] || [];
  if (selectedSubjects.length === allSubjects.length) {
    setSelectedSubjects([]);
  } else {
    setSelectedSubjects(allSubjects);
  }
};


// Remove a subject
const handleRemoveSubject = (subj) => {
  setSubjectMap(prev => ({
    ...prev,
    [selectedCourse]: prev[selectedCourse].filter(s => s !== subj),
  }));
  setSelectedSubjects(prev => prev.filter(s => s !== subj));
};

// Toggle subject selection
const handleToggleSubject = (subject) => {
  setSelectedSubjects(prev =>
    prev.includes(subject)
      ? prev.filter(s => s !== subject)
      : [...prev, subject]
  );
};



  const [examTypes, setExamTypes]  = useState([
    "UNIT_TEST_I",
    "UNIT_TEST_II",
    "UNIT_TEST_III",
    "QUATERLY",
    "HALF_YEARLY",
    "ANNUALLY",
  ]);

  const handleAddExamType = () => {
    const trimmed = customExamType.trim();
    if (trimmed && !examTypes.includes(trimmed)) {
      setExamTypes((prev) => [...prev, trimmed]);
      setSelectedExamType((prev) => [...prev, trimmed]);
    }
    setCustomExamType("");
  };

  const handleExamTypeToggle = (type) => {
    setSelectedExamType((prev) =>
      prev.includes(type)
        ? prev.filter((t) => t !== type)
        : [...prev, type]
    );
  };

  const handleExamTypeSelectAll = () => {
    if (selectedExamType.length === examTypes.length) {
      setSelectedExamType([]);
    } else {
      setSelectedExamType(examTypes);
    }
  };

  const handleRemoveType = (type) => {
    setExamTypes((prev) => prev.filter((t) => t !== type));
    setSelectedExamType((prev) => prev.filter((t) => t !== type));
  };




    // Class Registration Post Method
    const handleRegisterClass  = async () => {
      if (!selectedClass) {
        toast.error("Please select a Class");
        return;
      }
    
      if (selectedSections.length === 0) {
        toast.error("Please select at least one Section");
        return;
      }
    
      if (!selectedCourse) {
        toast.error("Please select a Course");
        return;
      }
    
      if (selectedSubjects.length === 0) {
        toast.error("Please select at least one Subject");
        return;
      }
    
      if (selectedExamType.length === 0) {
        toast.error("Please select an Exam Types");
        return;
      }
    
      const formData = new FormData();
    
      formData.append("userId", UserId);
      formData.append("classRegistration", selectedClass);
      formData.append("course", selectedCourse);
      formData.append("examType", selectedExamType);
    
      selectedSections.forEach((section) => {
        formData.append("classSectionLimit", section);
      });
    
      const finalSubjects =
        selectedSubjects.includes("Other") && customSubject
          ? [...selectedSubjects.filter((s) => s !== "Other"), customSubject]
          : selectedSubjects;
    
      finalSubjects.forEach((subject) => {
        formData.append("allSubject", subject);
      });
    
      try {
        setLoading(true);
    
        const response = await fetch(
          `${baseUrl}/api/dynamic-classReg/saveRegClass/${oId}/${pId}`,
          {
            method: "POST",
            body: formData,
          }
        );
    
        const responseData = await response.text();
    
        if (response.ok) {
          toast.success(`${selectedClass} ${selectedCourse} Registered Successful!`, { autoClose: 1000 });
          fetchTableData();
          setSelectedClass("");
          setSelectedCourse("")
          setSelectedSections([]);
          setSelectedSubjects([]);
          setSelectedExamType([]);
          setCustomSubject("");
        } else {
          toast.error(responseData || "Something went wrong!");
        }
      } catch (error) {
        toast.error("Network error. Please try again.");
        console.error("Error submitting:", error);
      } finally {
        setLoading(false);
      }
    };

      
  // GetMethod For Registered Classes 
  const fetchTableData = async ()=> {
    settableLoading(true);
    try {
      const response = await fetch(`${baseUrl}/api/dynamic-classReg/getAllRegClass/${oId}/${pId}`);
      const data = await response.json();
  
      if (response.ok && Array.isArray(data)) {
        setTableData(data);
      } else {
        console.warn("No data found or invalid format:", data);
        setTableData([]);
      }
    } catch (error) {
      console.error("Error loading class table:", error);
      setTableData([]);
    } finally {
      settableLoading(false);
    }
  };
  




// Edit CLASS TABLE CODE 
const safeSplit = (str) =>
  str
    ?.split(',')
    .map((item) => item.trim())
    .filter((item) => item !== '');

const handleBlur = () => {
  setRowSections(safeSplit(rowSectionsInput));
  setEditSubjects(safeSplit(editSubjectsInput));
  setEditExamType(safeSplit(editExamTypeInput));
};

const handleEditRow = (rowData) => {
setSelectedRow(rowData);
setEditClass(rowData.classRegistration);
setEditCourse(rowData.course);

setRowSections(safeSplit(rowData.classSectionLimit)); // ✅ fix here
setEditSubjects(safeSplit(rowData.allSubject));
setEditExamType(safeSplit(rowData.examTypes));

setIsEditModalOpen(true);
};





  

  // const handleEditRow = (rowData) => {
  //   setSelectedRow(rowData);
  //   setEditClass(rowData.classRegistration);
  //   setEditCourse(rowData.course);
  
  //   // ✅ Parse comma-separated string for sections
  //   setEditSections(
  //     typeof rowData.classSectionLimit === "string"
  //       ? rowData.classSectionLimit.split(",").map((s) => s.trim())
  //       : rowData.classSectionLimit || []
  //   );
  
  //   // ✅ Same logic for subjects
  //   setEditSubjects(
  //     typeof rowData.allSubject === "string"
  //       ? rowData.allSubject.split(",").map((s) => s.trim())
  //       : rowData.allSubject || []
  //   );
  
  //   // Parse comma-separated string for Exam Type
  //   setEditExamType(
  //     typeof rowData.examTypes === "string"
  //       ? rowData.examTypes.split(",").map((s) => s.trim())
  //       : rowData.examTypes || []
  //   );
  
  //   setIsEditModalOpen(true);
  // };
  
  
  const handleEditTimetableRow = (row) => {
    setSelectedRow(row);
    setEditPeriodNumber(row.periodNumber);
    setEditStartTime(row.startTime);
    setEditEndTime(row.endTime);
    setEditType(row.type);
    setIsTimetableEditModalOpen (true);
  };
  
  // Registered Classes update API
  const handleUpdateRow = async () => {
    if (!selectedRow) {
      toast.error("No row selected for update.");
      return;
    }
    setIsUpdating(true); // <-- Start loading
    try {
      const formData = new FormData();
  
      formData.append("classRegistration", editClass);
      formData.append("classSectionLimit", rowSections.join(","));
      formData.append("allSubject", editSubjects.join(","));
      formData.append("examTypes", editExamType);
      formData.append("course", editCourse);
  
      const response = await fetch(
        `${baseUrl}/api/dynamic-classReg/partialUpdateRegClass/${selectedRow.id}/${oId}/${pId}`,
        {
          method: "PATCH",
          body: formData,
        }
      );
  
      // let responseData = await response.text();
      
      
  
      if (!response.ok) {
        throw new Error("Error updating row"); // Directly throw text error
      }
  
      toast.success("Row updated successfully!", { autoClose: 1000 });
  
      // Optionally re-fetch table data from backend here
      fetchTableData();
  
      setIsEditModalOpen(false);
    } catch (error) {
      console.error("Error updating row:", error);
      toast.error(error.message, { autoClose: 2000 });
    }finally {
      setIsUpdating(false); // <-- Stop loading
    }
  };


    // Registered Classes delete action
    const handleDeleteRow = async (id) => {
      if (!id) {
        toast.error("Invalid row. Please select a valid row to delete.");
        return;
      }
    
      // Show SweetAlert2 confirmation
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            console.log("Deleting row with ID:", id);
            
    
            // Send DELETE request to API
            const response = await fetch(
              `${baseUrl}/api/dynamic-classReg/deleteById/${id}/${oId}/${pId}`,
              { method: "DELETE" }
            );
    
            if (!response.ok) {
              throw new Error("Failed to delete the row. Please try again.");
            }
    
            // Show success toast
            toast.success("Row deleted successfully!", { autoClose: 1000 });
    
            // Fetch fresh table data
            fetchTableData();
            
            // Show SweetAlert success message
            // Swal.fire("Deleted!", "Row has been deleted.", "success");
          } catch (error) {
            // console.error("Error deleting row:", error);
            toast.error(`Error deleting row: ${error.message}`);
          } 
        }
      });
    };


  


    
 
    

    // Timetable Scheduling
    const handleTimetableSubmit = async () => {
     
      if (
        selectedType !== "Interval Break" &&
        selectedType !== "Lunch Break" &&
        !periodNumber
      ) {
        toast.error("Please select a Period Number");
        return;
      }
      
          
            if (!startTime) {
              toast.error("Please select a Start Time");
              return;
            }
          
            if (!endTime) {
              toast.error("Please select an End Time");
              return;
            }
          
            if (!selectedType) {
              toast.error("Please select a Type");
              return;
            }
            
          
           
      const formData = new FormData();
      formData.append("userId", UserId); // Assuming `UserId` is already defined
      formData.append("periodNumber", periodNumber);
      formData.append("startTime", startTime);
      formData.append("endTime", endTime);
      formData.append("type", selectedType);
    
      try {
        setLoading(true);
    
        const response = await fetch(
          `${baseUrl}/api/dynamic-time-table/save/${oId}/${pId}`, // Replace endpoint as needed
          {
            method: "POST",
            body: formData,
          }
        );
    
        const responseData = await response.text();
    
        if (response.ok) {
          toast.success("Period scheduled successfully!", { autoClose: 1000 });
          // Optionally fetch fresh table data
           fetchScheduledPeriods(); 
         
          // Reset form
          setPeriodNumber("");
          setStartTime("");
          setEndTime("");
          setSelectedType("");
        } else {
          toast.error(responseData || "Something went wrong!", { autoClose: 2000 });
        }
      } catch (error) {
        toast.error("Network error. Please try again.");
        console.error("Error submitting timetable:", error);
      } finally {
        setLoading(false);
      }
    };


    // GetMethod For Scheduled Periods
    const fetchScheduledPeriods  = async () => {
      setScheduledPeriodsLoading(true);
      try {
        const response = await fetch(
          // `${baseUrl}/api/dynamic-time-table/getAllTimeSlots/${oId}`
          `${baseUrl}/api/dynamic-time-table/getAllTimeTableDetails/${oId}/${pId}`
        );
        const data = await response.json();
    
        console.log("API Response:", data); // ✅ Debug API Response
    
        if (response.ok) {
          setTimetableData(data); // ✅ Directly setting the array
        } else {
          console.warn("No data found:", data); // ✅ Log if empty
          setTimetableData([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setTimetableData([]);
      } finally {
        setScheduledPeriodsLoading(false);
      }
    };
 

   




    
    // Scheduled Periods update API
    const handleUpdateTimetableRow = async () => {
      if (!selectedRow) {
        toast.error("No row selected for update.");
        return;
      }
    
      try {
        const formData = new FormData();
        formData.append("periodNumber", editPeriodNumber);
        formData.append("startTime", editStartTime);
        formData.append("endTime", editEndTime);
        formData.append("type", editType);
    
        const response = await fetch(
          `${baseUrl}/api/dynamic-time-table/partialUpdate/${selectedRow.id}/${oId}/${pId}`,
          {
            method: "PATCH",
            body: formData,
          }
        );
    
        let responseData;
        try {
          responseData = await response.text();
        } catch (textError) {
          console.error("Error parsing response as text:", textError);
          responseData = "Unknown error occurred.";
        }
    
        if (!response.ok) {
          throw new Error(responseData);
        }
    
        toast.success("Timetable entry updated successfully!", { autoClose: 1000 });
    
        // Update the table data with new values
        setTableData((prevData) =>
          prevData.map((row) =>
            row.id === selectedRow.id
              ? {
                  ...row,
                  periodNumber: editPeriodNumber,
                  startTime: editStartTime,
                  endTime: editEndTime,
                  type: editType,
                }
              : row
          )
        );
    
        setSelectedRow(null);
        setIsTimetableEditModalOpen(false);
      } catch (error) {
        console.error("Error updating timetable entry:", error);
        toast.error(error.message, { autoClose: 3000 });
      }
    };

  
    // Scheduled Periods delete action
const handleDeleteScheduledPeriod = async (row) => {
  
  if (!row.id) {
    toast.error("Invalid row. Please select a valid row to delete.");
    return;
  }
  

  // Show SweetAlert2 confirmation
  Swal.fire({
    title: "Are you sure?",
    text: `You want to delete Period "${row.periodNumber}"`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, delete it!",
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        console.log("Deleting row with ID:", row.id);
       

        // Send DELETE request to API
        const response = await fetch(
          `${baseUrl}/api/dynamic-time-table/delete/${row.id}`,
          { method: "DELETE" }
        );

        if (!response.ok) {
          throw new Error("Failed to delete the row. Please try again.");
        }

        // Show success toast
        toast.success(`Period ${row.periodNumber} deleted successfully!`, { autoClose: 1000 });
        fetchScheduledPeriods(); 
       
      } catch (error) {
        console.error("Deletion error:", error);
        toast.error(`Error deleting row: ${error.message}`);
      } 
    }
  });
};
const [typeOptions, setTypeOptions] = useState([
  "Period",
  "Interval Break",
  "Lunch Break",
]);
const [selectedType, setSelectedType] = useState("");
const [customType, setCustomType] = useState("");
const [open, setOpen] = useState(false); // manually control select open/close

const handleAddType = () => {
  const newType = customType.trim();
  if (newType && !typeOptions.includes(newType)) {
    setTypeOptions([...typeOptions, newType]);
    setSelectedType(newType);
  }
  setCustomType("");
};

const handleRemoveScheduledType = (value) => {
  setTypeOptions(typeOptions.filter((v) => v !== value));
  if (selectedType === value) setSelectedType("");
};


    
    

  return (
    <Box sx={{ mt: "5%", mr: "1%", ml: "1%" }}>
      <Card
        sx={{
          marginTop: "60px",
          width: "100%",
          borderRadius: 3,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Box display="flex">
          {/* Sidebar */}
          <Box sx={{ width: 200, bgcolor: "#f9f9f9", borderRight: "1px solid #eee", p: 2 }}>
            <Typography variant="h5" sx={{ mb: 2, fontWeight: "bold" }}>
              Settings
            </Typography>
            <List>
              {menuItems.map((item) => (
                <ListItem
                  key={item}
                  button
                  selected={selectedMenu === item}
                  onClick={() => setSelectedMenu(item)}
                  sx={{
                    borderRadius: 1,
                    "&.Mui-selected": {
                      backgroundColor: "#e0e0ff",
                      fontWeight: "bold",
                      borderLeft: "4px solid #3f51b5",
                    },
                  }}
                >
                  <ListItemText primary={item} primaryTypographyProps={{fontWeight:'bold'}}  />
                </ListItem>
              ))}
            </List>
          </Box>

          {/* Content Area */}
          <Box sx={{ flex: 1, p: 4 }}>
            <Typography variant="h5" sx={{ mb: 3, fontWeight: "bold" }}>
              {selectedMenu}
            </Typography>
            <Divider sx={{ mb: 3 }} />
            
            {/* Class Registration */}
              {selectedMenu === "Class Registration" ? (
              <Box>

                {/* --- Form Card --- */}
                <Paper elevation={1} sx={{ p: 3, borderRadius: 2, mb: 4 }}>
                      <Typography variant="h5" sx={{paddingBottom:"10px",fontWeight:'bold'}}>
                        Register Class
                      </Typography>
                      {/* <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap"> */}

 <Grid container spacing={1} >
  {/* Class Dropdown */}
                  <Grid item xs={12} sm={6} md={3}>
                    {/* Year Dropdown */}
                    <FormControl fullWidth size="small">
                        <InputLabel >Select Year</InputLabel>
                        <Select
                          value={selectedClass}
                          onChange={(e) => setSelectedClass(e.target.value)}
                          input={<OutlinedInput label="Select Year"  />}
                          renderValue={(selected) =>
                            selected ? (
                              <span style={{ color: "#000" }}>{selected}</span>
                            ) : (
                              <span style={{ color: "#888" }}>Select Year</span>
                            )
                          }
                          MenuProps={{ PaperProps: { style: {width:'160px'} } }}
                        >
                          <MenuItem disabled value="">
                            Select Year
                          </MenuItem>
                          {classOptions.map((cls) => (
                            <MenuItem key={cls} value={cls}>
                              {cls}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                    {/* Section Dropdown */}
                    <FormControl fullWidth size="small">
                    <InputLabel >Select Section</InputLabel>
                      <Select
                        multiple
                        
                        value={selectedSections}
                        input={<OutlinedInput label="Select Section" />}

                        onChange={(e) => setSelectedSections(e.target.value)}
                        renderValue={(selected) =>
                          selected.length ? selected.join(", ") : "Select Sections"
                        }
                        MenuProps={{ PaperProps: { style: {width:'160px'} } }}
                      >
                        {sectionOptions.map((sec) => (
                          <MenuItem key={sec} value={sec}>
                            <Checkbox checked={selectedSections.includes(sec)} />
                            {sec}
                          </MenuItem>
                        ))}

                        {/* "+" Button to Add Section */}
                        <MenuItem
                          onClick={(e) => {
                            e.stopPropagation();
                            const lastSection = sectionOptions[sectionOptions.length - 1];
                            const lastChar = lastSection.slice(-1); // e.g., "A"
                            const nextChar = String.fromCharCode(lastChar.charCodeAt(0) + 1);
                            const nextSection = `Section-${nextChar}`;

                            if (!sectionOptions.includes(nextSection)) {
                              setSectionOptions([...sectionOptions, nextSection]);
                            }
                          }}
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            color: "#1976d2",
                            fontWeight: "bold",
                            borderTop: "1px solid #eee",
                          }}
                        >
                          + Add Section
                        </MenuItem>
                      </Select>
                      </FormControl>
                      </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                    {/* Courses Dropdown */}
                    <FormControl fullWidth size="small">
                      <InputLabel>Select Course</InputLabel>
                      <Select
                        value={selectedCourse}
                        onChange={(e) => {
                          setSelectedCourse(e.target.value);
                          setSelectedSubjects([]);
                        }}
                        input={<OutlinedInput label="Select Course" />}
                        renderValue={(selected) => selected || "Select Course"}
                        MenuProps={{ PaperProps: { style: { width: '160px' } } }}
                      >
                        {/* Add Course Field using ListSubheader */}
                        <ListSubheader
                          disableSticky
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            px: 1,
                            py: 1,
                            bgcolor: 'background.paper',
                            '&:hover': { bgcolor: 'background.paper' }
                          }}
                          onMouseDown={(e) => e.stopPropagation()}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <Box display="flex" gap={1} width="100%">
                            <TextField
                              placeholder="Add Course"
                              value={customCourse}
                              onChange={(e) => setCustomCourse(e.target.value)}
                              size="small"
                              fullWidth
                              autoFocus
                              onKeyDown={(e) => {
                                e.stopPropagation();
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  handleAddCourse();
                                }
                              }}
                            />
                            <IconButton
                              onClick={(e) => {
                                e.stopPropagation();
                                handleAddCourse();
                              }}
                              size="small"
                            >
                              <AddIcon fontSize="small" />
                            </IconButton>
                          </Box>
                        </ListSubheader>

                        {/* Course Options */}
                        {courseOptions.map((course) => (
                          <MenuItem
                            key={course}
                            value={course}
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              "&:hover .delete-icon": {
                                visibility: "visible"
                              }
                            }}
                          >
                            <Box
                              display="flex"
                              alignItems="center"
                              justifyContent="space-between"
                              width="100%"
                            >
                              <Typography>{course}</Typography>
                              <IconButton
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleRemoveCourse(course);
                                }}
                                className="delete-icon"
                                sx={{ visibility: "hidden" }}
                              >
                                <CloseIcon fontSize="small" />
                              </IconButton>
                            </Box>
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    </Grid>


                    <Grid item xs={12} sm={6} md={3}>
                   {/* subjects DropDown */}
                   <FormControl fullWidth size="small" disabled={!selectedCourse}>
                          <InputLabel>Select Subjects</InputLabel>
                          <Select
                            multiple
                            value={selectedSubjects}
                            input={<OutlinedInput label="Select Subjects" />}
                            renderValue={(selected) => selected.join(", ")}
                            MenuProps={{ PaperProps: { style: { maxHeight: 300, width: '160px' } } }}
                          >
                            {/* Subject input & add button */}
                            <MenuItem disableRipple disableTouchRipple>
                              <Box display="flex" gap={1} width="100%">
                                <TextField
                                  placeholder="Add Subject"
                                  value={customSubject}
                                  onChange={(e) => setCustomSubject(e.target.value)}
                                  size="small"
                                  fullWidth
                                  onKeyDown={(e) => {
                                    e.stopPropagation();
                                    if (e.key === "Enter") {
                                      e.preventDefault();
                                      handleAddSubject();
                                    }
                                  }}
                                />
                                <IconButton onClick={handleAddSubject} size="small">
                                  <AddIcon fontSize="small" />
                                </IconButton>
                              </Box>
                            </MenuItem>

                            {/* Select All Option */}
                            <MenuItem onClick={handleSelectAll}>
                              <Checkbox
                                checked={
                                  subjectMap[selectedCourse]?.length > 0 &&
                                  selectedSubjects.length === subjectMap[selectedCourse].length
                                }
                                indeterminate={
                                  selectedSubjects.length > 0 &&
                                  selectedSubjects.length < (subjectMap[selectedCourse]?.length || 0)
                                }
                              />
                              <Typography>Select All</Typography>
                            </MenuItem>

                            {/* Subject List */}
                            {(subjectMap[selectedCourse] || []).map((subj) => (
                              <MenuItem
                                key={subj}
                                onClick={() => handleToggleSubject(subj)}
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  "&:hover .remove-icon": { visibility: "visible" },
                                }}
                              >
                                <Box display="flex" alignItems="center">
                                  <Checkbox checked={selectedSubjects.includes(subj)} />
                                  <Typography>{subj}</Typography>
                                </Box>
                                <IconButton
                                  className="remove-icon"
                                  size="small"
                                  sx={{ visibility: "hidden" }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleRemoveSubject(subj);
                                  }}
                                >
                                  <CloseIcon fontSize="small" />
                                </IconButton>
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        </Grid>

                      {/* Exam Type Dropdown */}
                      <Grid item xs={12} sm={6} md={3}>
                    
                    <FormControl fullWidth size="small">
                          <InputLabel id="exam-type-label">Select Exam Type</InputLabel>
                          <Select
                            labelId="exam-type-label"
                            multiple
                            value={selectedExamType}
                            input={<OutlinedInput label="Select Exam Type" />}
                            renderValue={(selected) =>
                              selected.length > 0 ? selected.join(", ") : "Select Exam Type"
                            }
                            MenuProps={{ PaperProps: { style: {width:'160px'} } }}
                          >
                            
                            <MenuItem disableRipple disableTouchRipple>
                              <Box display="flex" gap={1} width="100%">
                                <TextField
                                  placeholder="Add Exam Type"
                                  value={customExamType}
                                  onChange={(e) => setCustomExamType(e.target.value)}
                                  size="small"
                                  fullWidth
                                  onKeyDown={(e) => {
                                    e.stopPropagation();
                                    if (e.key === "Enter") {
                                      e.preventDefault();
                                      handleAddExamType();
                                    }
                                  }}
                                />
                                
                                <IconButton
                      size="small"
                      onClick={handleAddExamType}
                      sx={{
                        color: "gray", // default color
                        "&:hover": {
                          color: "black", // hover color
                          backgroundColor: "transparent", // prevent background
                        },
                        "&:active": {
                          color: "black", // optional: active/click color
                        },
                      }}
                    >
                      <AddIcon fontSize="medium" />
                    </IconButton>
                              </Box>
                            </MenuItem>

                            
                            <MenuItem onClick={handleExamTypeSelectAll}>
                              <Checkbox
                                checked={selectedExamType.length === examTypes.length}
                                indeterminate={
                                  selectedExamType.length > 0 &&
                                  selectedExamType.length < examTypes.length
                                }
                              />
                              <Typography>Select All</Typography>
                            </MenuItem>

                            
                            {examTypes.map((type) => (
                              <MenuItem
                                key={type}
                                onClick={() => handleExamTypeToggle(type)}
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  "&:hover .remove-icon": { visibility: "visible" },
                                }}
                              >
                                <Box display="flex" alignItems="center">
                                  <Checkbox checked={selectedExamType.includes(type)} />
                                  <Typography>{type}</Typography>
                                </Box>
                                <IconButton
                                  className="remove-icon"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleRemoveType(type);
                                  }}
                                  size="small"
                                  sx={{ visibility: "hidden" }}
                                >
                                  <CloseIcon fontSize="small" />
                                </IconButton>
                              </MenuItem>
                            ))}
                          </Select>
                      </FormControl>
                      </Grid>

                    </Grid>

                  {/* Submit Button */}
                  <Grid item xs={12} sm={6} md={3} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" ,marginTop:'10px'}}>
                    
                   
                    <Button
                      variant="contained"
                      disabled={loading}
                      sx={{
                        width: 93,
                        height: 38,
                        backgroundColor: "#3C3972",
                        "&:hover": { backgroundColor: "#2e2b59" },
                      }}
                      onClick={handleRegisterClass}
                    >
                      {loading ? (
                        <Box display="flex" alignItems="center" gap={1}>
                          <CircularProgress size={20} sx={{ color: "white" }} />
                          Loading...
                        </Box>
                      ) : (
                        "Submit"
                      )}
                    </Button>
                    
                    </Grid>
                  {/* </Stack> */}
                </Paper>
              
                {/* --- Table Card --- */}
                <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}>
                  <Typography variant="h5" sx={{paddingBottom:"10px",fontWeight:'bold'}}>
                    Registered Classes
                  </Typography>
              
                  <GlobalStyles
                    styles={{
                      '.custom-sidebar-scrollbar': {
                        scrollbarWidth: 'thin',
                        scrollbarColor: 'grey #e0e0e0',
                      },
                      '.custom-sidebar-scrollbar::-webkit-scrollbar': {
                        width: '6px',
                      },
                      '.custom-sidebar-scrollbar::-webkit-scrollbar-track': {
                        background: '#f1f1f1',
                      },
                      '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb': {
                        backgroundColor: 'grey',
                        borderRadius: '10px',
                      },
                      '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover': {
                        backgroundColor: '#555',
                      },
                    }}
                  />
              
                  <TableContainer
                    component={Paper}
                    sx={{
                      borderRadius: 2,
                      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                      maxHeight: "350px",
                      overflow: "auto",
                      mt: 2,
                    }}
                    className="custom-sidebar-scrollbar"
                  >
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                        {/* <TableCell sx={headerStyle}>S.No</TableCell> */}
                        <TableCell sx={headerStyle}>Course</TableCell>
                          <TableCell sx={headerStyle}>Year</TableCell>
                          <TableCell sx={headerStyle}>Sections</TableCell>
                          <TableCell sx={headerStyle}>Subjects</TableCell>
                          <TableCell sx={headerStyle}>ExamType</TableCell>
                          <TableCell sx={headerStyle}>Action</TableCell>
                        </TableRow>
                      </TableHead>
              
                      {tableLoading ? (
                        <TableBody>
                          <TableRow>
                            <TableCell colSpan={9} style={{ textAlign: "center", padding: "20px" }}>
                              <Box display="flex" flexDirection="column" alignItems="center">
                                <CircularProgress />
                                <Typography variant="body2" sx={{ mt: 1 }}>Loading Data...</Typography>
                              </Box>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      ) : tableData.length === 0 ? (
                        <TableBody>
                          <TableRow>
                            <TableCell colSpan={9} sx={{ textAlign: "center", padding: "20px" }}>
                              No data found
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      ) : (
                        <TableBody>
                          {tableData.map((row, index) => (
                            <TableRow key={index} sx={{ backgroundColor: "white", "&:hover": { backgroundColor: "#f5f5f5" } }}>
                              {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "6px", textAlign: "center" }}>
                                {index+1}
                              </TableCell> */}
                              <TableCell sx={{ borderRight: "1px solid #ddd", padding: "6px", textAlign: "center" }}>
                                {row.course}
                              </TableCell>
                              <TableCell sx={{ borderRight: "1px solid #ddd", padding: "6px", textAlign: "center" }}>
                                {row.classRegistration}
                              </TableCell>
                              <TableCell sx={{ borderRight: "1px solid #ddd", padding: "6px", textAlign: "center" }}>
                                {row.classSectionLimit}
                              </TableCell>
                              <TableCell sx={{ width: 230, maxWidth: 230, whiteSpace: "normal", wordWrap: "break-word", borderRight: "1px solid #ddd", padding: "6px", textAlign: "center" }}>
                                {row.allSubject}
                              </TableCell>
                              <TableCell sx={{ width: 230, maxWidth: 230, whiteSpace: "normal", wordWrap: "break-word", borderRight: "1px solid #ddd", padding: "6px", textAlign: "center" }}>
                                {row.examTypes}
                              </TableCell>
                              <TableCell sx={{ borderRight: "1px solid #ddd", padding: "6px", textAlign: "center" }}>
                                <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
                                  <Button
                                    variant="contained"
                                    sx={{
                                      backgroundColor: "#1976d2",
                                      color: "white",
                                      minWidth: "60px",
                                      fontSize: "0.75rem",
                                      padding: "3px 8px",
                                      "&:hover": { backgroundColor: "#1565c0" },
                                    }}
                                    size="small"
                                    onClick={() => handleEditRow(row)}
                                  >
                                    Edit
                                  </Button>
                                  <Button
                                    variant="contained"
                                    sx={{
                                      backgroundColor: "#a82814",
                                      color: "#fff",
                                      minWidth: "60px",
                                      fontSize: "0.75rem",
                                      padding: "3px 8px",
                                      "&:hover": { backgroundColor: "#7a1b0e" },
                                    }}
                                    size="small"
                                    onClick={() => handleDeleteRow(row.id)}
                                  >
                                    Delete
                                  </Button>
                                </Box>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      )}
                    </Table>
                  </TableContainer>
                </Paper>
              
                {/* --- Edit Modal --- */}
                {isEditModalOpen && selectedRow && (
                  <Modal open={isEditModalOpen} onClose={() => setIsEditModalOpen(false)}>
                    <Box
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: 500,
                        bgcolor: "background.paper",
                        boxShadow: 24,
                        p: "1% 2% 1% 2%",
                        borderRadius: 2,
                      }}
                    >
                      <Typography variant="h4" sx={{fontWeight:'bold',paddingBottom:'20px'}}>Edit Class Registration</Typography>
              
                      <Stack spacing={2}>

                        {/* Course Dropdown */}
                      <FormControl fullWidth>
                          <InputLabel>Course</InputLabel>
                          <Select
                            value={editCourse}
                            label="Course"
                            onChange={(e) => setEditCourse(e.target.value)}
                            disabled
                            sx={{
                              backgroundColor: "#f0f0f0",
                              color: "#6c757d",
                              fontWeight: "bold",
                            }}
                          >
                            {courseOptions.map((cls) => (
                              <MenuItem key={cls} value={cls}>{cls}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {/* Year Dropdown */}
                        <FormControl fullWidth>
                          <InputLabel>Year</InputLabel>
                          <Select
                            value={editClass}
                            label="Year"
                            onChange={(e) => setEditClass(e.target.value)}
                            disabled
                            sx={{
                              backgroundColor: "#f0f0f0",
                              color: "#6c757d",
                              fontWeight: "bold",
                            }}
                          >
                            {classOptions.map((cls) => (
                              <MenuItem key={cls} value={cls}>{cls}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
              



              <TextField
                                        label="Sections"
                                        value={rowSectionsInput}
                                        onChange={handleInputChange(setRowSectionsInput)}
                                        onBlur={handleBlur}
                                        fullWidth
                                        margin="normal"
                                        size="medium"
                                      />
              
                                      <TextField
                                        label="Subjects"
                                        value={editSubjectsInput}
                                        onChange={handleInputChange(setEditSubjectsInput)}
                                        onBlur={handleBlur}
                                        fullWidth
                                        margin="normal"
                                        size="medium"
                                      />
              
                                      <TextField
                                        label="Exam Types"
                                        value={editExamTypeInput}
                                        onChange={handleInputChange(setEditExamTypeInput)}
                                        onBlur={handleBlur}
                                        fullWidth
                                        margin="normal"
                                        size="medium"
                                      />
              
                        {/* Sections */}
                        {/* <FormControl fullWidth>
                          <InputLabel>Select Sections</InputLabel>
                          <Select
                            multiple
                            value={editSections}
                            label="Select Sections"
                            onChange={(e) => setEditSections(e.target.value)}
                            renderValue={(selected) => selected.join(", ")}
                          >
                            {sectionOptions.map((sec) => (
                              <MenuItem key={sec} value={sec}>
                                <Checkbox checked={editSections.includes(sec)} />
                                {sec}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl> */}
              
                        {/* Subjects */}
                       {/* <FormControl fullWidth>
                          <InputLabel>Select Subjects</InputLabel>
                          <Select
                            multiple
                            value={editSubjects}  // This should reflect the selected subjects in the state
                            onChange={(e) => setEditSubjects(e.target.value)}  // Updates the editSubjects state with selected subjects
                            label="Select Subjects"
                            renderValue={(selected) => selected.join(", ")}  // Display comma-separated values in the field
                          >
                            {(subjectMap[editCourse] || []).map((subj) => (
                              <MenuItem key={subj} value={subj}>
                                <Checkbox checked={editSubjects.includes(subj)} />  
                                {subj}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl> */}

              
                        {/* Exam Type */}
                        {/* <FormControl fullWidth>
                          <InputLabel>Exam Type</InputLabel>
                          <Select
                            multiple
                            value={editExamType}
                            label="Exam Type"
                            onChange={(e) => setEditExamType(e.target.value)}
                            renderValue={(selected) => selected.join(", ")}
                          >
                            {examTypes.map((type) => (
                              <MenuItem key={type} value={type}>
                                <Checkbox checked={editExamType.includes(type)} />
                                {type}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl> */}
                    

              
                        {/* Modal Actions */}
                        <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
                          <Button variant="outlined" onClick={() => setIsEditModalOpen(false)}>Cancel</Button>
                          <Button
                              variant="contained"
                              sx={{ backgroundColor: "#3C3972", color: "white", minWidth: 100,'&:hover': {
                                                                backgroundColor: "#3C3972"} }}
                              onClick={() => {
                                const updatedRow = {
                                  ...selectedRow,
                                  classRegistration: editClass,
                                  classSectionLimit: editSections.join(", "),
                                  allSubject: editSubjects.join(", "),
                                  examTypes: editExamType,
                                };
                                handleUpdateRow(updatedRow);
                              }}
                              disabled={isUpdating} // disable button while loading
                            >
                              {isUpdating ? (
                                <CircularProgress size={20} sx={{ color: "white" }} />
                              ) : (
                                "Save"
                              )}
                            </Button>

                        </Box>
                      </Stack>
                    </Box>
                  </Modal>
                )}
              
              </Box>
 
                
                           ) :selectedMenu === "TimeTable Schedule" ? (
                             <Box sx={{ overflowX: 'auto', width: '100%' }}>
                             {/* --- Timetable Scheduling Form --- */}
                             <Paper elevation={3} sx={{ p: "1% 2% 2% 2%", borderRadius: 2, mb: 4 }}>
                               <Typography variant="h5" sx={{paddingBottom:"10px",fontWeight:'bold'}}>
                                 TimeTable Schedule
                               </Typography>
                               {/* <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap"> */}
                               <Stack
                 direction="row"
                 spacing={2}
                 alignItems="center"
                 sx={{ minWidth: 'max-content', flexWrap: 'nowrap' }}
               >
                                 <TextField
                                   label="Period Number"
                                   type="number"
                                   value={periodNumber}
                                   onChange={(e) => setPeriodNumber(e.target.value)}
                                   sx={{ width: 150 }}
                                   size="small"
                                 />
                                 <TextField
                                   label="Start Time"
                                   type="time"
                                   value={startTime}
                                   onChange={(e) => setStartTime(e.target.value)}
                                   sx={{ width: 150 }}
                                   size="small"
                                   InputLabelProps={{ shrink: true }}
                                 />
                                 <TextField
                                   label="End Time"
                                   type="time"
                                   value={endTime}
                                   onChange={(e) => setEndTime(e.target.value)}
                                   sx={{ width: 150 }}
                                   size="small"
                                   InputLabelProps={{ shrink: true }}
                                 />
             
             
             {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
               
               <TimePicker
                 label="Start Time"
                 value={startTime ? dayjs(startTime, "hh:mm A") : null}
                 onChange={(newValue) => {
                   setStartTime(newValue ? newValue.format("hh:mm A") : "");
                 }}
                 ampm
                 sx={{ width: 150 }}
                 slotProps={{
                   textField: {
                     size: "small",
                     sx: { mb: 1 },
                     InputLabelProps: { shrink: true },
                   },
                 }}
               />
             
               
               <TimePicker
                 label="End Time"
                 value={endTime ? dayjs(endTime, "hh:mm A") : null}
                 onChange={(newValue) => {
                   setEndTime(newValue ? newValue.format("hh:mm A") : "");
                 }}
                 ampm
                 sx={{ width: 150 }}
                 slotProps={{
                   textField: {
                     size: "small",
                     sx: { mb: 1 },
                     InputLabelProps: { shrink: true },
                   },
                 }}
               />
             </LocalizationProvider> */}
             
             
             
             
             
             <FormControl sx={{ width: 200 }} size="small">
               <InputLabel>Select Type</InputLabel>
               <Select
                 open={open}
                 onOpen={() => setOpen(true)}
                 onClose={() => setOpen(false)}
                 value={selectedType}
                 label="Select Type"
                 onChange={(e) => {
                   setSelectedType(e.target.value);
                   setOpen(false);
                 }}
                 renderValue={(selected) => selected || "Select Type"}
                 MenuProps={{
                   PaperProps: { style: { width: "200px" } },
                 }}
               >
                 {/* Render input only when dropdown is open */}
                 {open && (
                   <MenuItem disableRipple disableTouchRipple>
                     <Box display="flex" gap={1} width="100%">
                       <TextField
                         placeholder="Add Type"
                         value={customType}
                         onChange={(e) => setCustomType(e.target.value)}
                         size="small"
                         fullWidth
                         autoFocus
                         onClick={(e) => e.stopPropagation()}
                         onKeyDown={(e) => {
                           e.stopPropagation();
                           if (e.key === "Enter") {
                             e.preventDefault();
                             handleAddType();
                           }
                         }}
                       />
                       <IconButton
                         size="small"
                         onClick={(e) => {
                           e.stopPropagation();
                           handleAddType();
                         }}
                         sx={{
                           color: "gray",
                           "&:hover": {
                             color: "black",
                             backgroundColor: "transparent",
                           },
                         }}
                       >
                         <AddIcon fontSize="medium" />
                       </IconButton>
                     </Box>
                   </MenuItem>
                 )}
             
                 {typeOptions.map((opt) => (
                   <MenuItem
                     key={opt}
                     value={opt}
                     sx={{
                       display: "flex",
                       justifyContent: "space-between",
                       alignItems: "center",
                       "&:hover .remove-icon": { visibility: "visible" },
                     }}
                   >
                     <Typography>{opt}</Typography>
                     <IconButton
                       className="remove-icon"
                       onClick={(e) => {
                         e.stopPropagation();
                         handleRemoveScheduledType(opt);
                       }}
                       size="small"
                       sx={{ visibility: "hidden" }}
                     >
                       <CloseIcon fontSize="small" />
                     </IconButton>
                   </MenuItem>
                 ))}
               </Select>
             </FormControl>
             
             {/* </Stack> */}
             {/* <div sx={{display: "flex", justifyContent: "flex-end", alignItems: "center" ,marginTop:'10px'}}> */}
                                 <Button
                                   variant="contained"
                                   sx={{
                                     height: 36,
                                     backgroundColor: "#3C3972",
                                     "&:hover": { backgroundColor: "#2e2b59" },
                                   }}
                                   onClick={handleTimetableSubmit}
                                 >
                                   {loading ? (
                                     <>
                                       <CircularProgress size={20} sx={{ color: "white", marginRight: 1 }} />
                                       Submit
                                     </>
                                   ) : (
                                   "Submit"
                                 )}
                                 </Button>
                                 {/* </div> */}
             
             
                                 </Stack>
                             </Paper>
                           
                             {/* --- Timetable Table --- */}
                             <Paper elevation={3} sx={{ p: "1% 2% 2% 2%", borderRadius: 2 }}>
                               <Typography variant="h5" sx={{paddingBottom:"10px",fontWeight:'bold'}}>
                                 Scheduled Periods
                               </Typography>
             
                               <GlobalStyles
                                 styles={{
                                   ".custom-sidebar-scrollbar": {
                                     scrollbarWidth: "thin",
                                     scrollbarColor: "grey #e0e0e0",
                                   },
                                   ".custom-sidebar-scrollbar::-webkit-scrollbar": {
                                     width: "6px",
                                   },
                                   ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
                                     background: "#f1f1f1",
                                   },
                                   ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
                                     backgroundColor: "grey",
                                     borderRadius: "10px",
                                   },
                                   ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
                                     backgroundColor: "#555",
                                   },
                                 }}
                               />
             
                               <TableContainer
                                 component={Paper}
                                 className="custom-sidebar-scrollbar"
                                 sx={{
                                   borderRadius: 2,
                                   boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                                   maxHeight: "350px",
                                   overflow: "auto",
                                   mt: 2,
                                 }}
                               >
                                 <Table stickyHeader>
                                   <TableHead>
                                     <TableRow>
                                       <TableCell sx={headerStyle}>Period No</TableCell>
                                       <TableCell sx={headerStyle}>Start Time</TableCell>
                                       <TableCell sx={headerStyle}>End Time</TableCell>
                                       <TableCell sx={headerStyle}>Type</TableCell>
                                       <TableCell sx={headerStyle}>Action</TableCell>
                                     </TableRow>
                                   </TableHead>
             
                                   <TableBody>
                                     {scheduledPeriodsLoading ? (
                                       <TableRow>
                                         <TableCell colSpan={5} style={{ textAlign: "center", padding: "20px" }}>
                                           <Box display="flex" flexDirection="column" alignItems="center">
                                             <CircularProgress />
                                             <Typography variant="body2" sx={{ mt: 1 }}>
                                               Loading Data...
                                             </Typography>
                                           </Box>
                                         </TableCell>
                                       </TableRow>
                                     ) : timetableData.length === 0 ? (
                                       <TableRow>
                                         <TableCell colSpan={5} sx={{ textAlign: "center" }}>
                                           No data found
                                         </TableCell>
                                       </TableRow>
                                     ) : (
                                       timetableData.map((row, index) => (
                                         <TableRow
                                           key={index}
                                           sx={{
                                             backgroundColor: "white",
                                             "&:hover": { backgroundColor: "#f5f5f5" },
                                           }}
                                         >
                                           <TableCell sx={cellStyle}>{row.periodNumber || "Break"}</TableCell>
                                           <TableCell sx={cellStyle}>{row.startTime}</TableCell>
                                           <TableCell sx={cellStyle}>{row.endTime}</TableCell>
                                           <TableCell sx={cellStyle}>{row.type}</TableCell>
                                           <TableCell sx={cellStyle}>
                                             <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
                                               {/* <Button
                                                 variant="contained"
                                                 size="small"
                                                 sx={{
                                                   backgroundColor: "#1976d2",
                                                   color: "white",
                                                   fontSize: "0.75rem",
                                                   padding: "3px 8px",
                                                   "&:hover": { backgroundColor: "#1565c0" },
                                                 }}
                                                 onClick={() => handleEditTimetableRow(row)}
                                               >
                                                 Edit
                                               </Button> */}
                                               <Button
                                                 variant="contained"
                                                 size="small"
                                                 sx={{
                                                   backgroundColor: "#a82814",
                                                   color: "white",
                                                   fontSize: "0.75rem",
                                                   padding: "3px 8px",
                                                   "&:hover": { backgroundColor: "#7a1b0e" },
                                                 }}
                                                 onClick={() => 
                                                   {
                                                     console.log("Deleting row:", row); 
                                                     handleDeleteScheduledPeriod(row)}}
                                               >
                                                 Delete
                                               </Button>
                                             </Box>
                                           </TableCell>
                                         </TableRow>
                                       ))
                                     )}
                                   </TableBody>
                                 </Table>
                               </TableContainer>
                             </Paper>
             
                                   {/* --- Edit Modal --- */}
                                 {isTimetableEditModalOpen  && selectedRow && (
                                   <Modal open={isTimetableEditModalOpen } onClose={() => setIsTimetableEditModalOpen (false)}>
                                     <Box
                                       sx={{
                                         position: "absolute",
                                         top: "50%",
                                         left: "50%",
                                         transform: "translate(-50%, -50%)",
                                         width: 400,
                                         bgcolor: "background.paper",
                                         boxShadow: 24,
                                         p: 4,
                                         borderRadius: 2,
                                       }}
                                     >
                                       <Typography variant="h6" gutterBottom>
                                         Edit Scheduled Period
                                       </Typography>
             
                                       <Stack spacing={2}>
                                         {/* Period Number */}
                                         <TextField
                                           fullWidth
                                           label="Period Number"
                                           type="number"
                                           value={editPeriodNumber}
                                           onChange={(e) => setEditPeriodNumber(e.target.value)}
                                         />
             
                                         {/* Start Time */}
                                         <TextField
                                           fullWidth
                                           label="Start Time"
                                           type="time"
                                           InputLabelProps={{ shrink: true }}
                                           value={editStartTime}
                                           onChange={(e) => setEditStartTime(e.target.value)}
                                         />
             
                                         {/* End Time */}
                                         <TextField
                                           fullWidth
                                           label="End Time"
                                           type="time"
                                           InputLabelProps={{ shrink: true }}
                                           value={editEndTime}
                                           onChange={(e) => setEditEndTime(e.target.value)}
                                         />
             
                                         {/* Type */}
                                         <FormControl fullWidth>
                                           <InputLabel>Type</InputLabel>
                                           <Select
                                             value={editType}
                                             label="Type"
                                             onChange={(e) => setEditType(e.target.value)}
                                           >
                                             {["Lecture", "Break", "Lab", "Activity"].map((option) => (
                                               <MenuItem key={option} value={option}>
                                                 {option}
                                               </MenuItem>
                                             ))}
                                           </Select>
                                         </FormControl>
             
                                         {/* Modal Actions */}
                                         <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
                                           <Button variant="outlined" onClick={() => setIsTimetableEditModalOpen (false)}>
                                             Cancel
                                           </Button>
                                           <Button
                                             variant="contained"
                                             sx={{ backgroundColor: "#3C3972", color: "white" }}
                                             onClick={() => {
                                               const updatedRow = {
                                                 ...selectedRow,
                                                 periodNumber: editPeriodNumber,
                                                 startTime: editStartTime,
                                                 endTime: editEndTime,
                                                 type: editType,
                                               };
                                               handleUpdateTimetableRow (updatedRow);
                                               setIsTimetableEditModalOpen (false);
                                             }}
                                           >
                                             Save
                                           </Button>
                                         </Box>
                                       </Stack>
                                     </Box>
                                   </Modal>
                                 )}
             
                           
             
                           </Box>
                           
                           ) :selectedMenu === "Receipt Prefix" ? (
                             
                  <Card
               sx={{
                 maxWidth: 800,          // a bit wider for the whole row
                 mx: "auto",
                 mt: 4,
                 p: 3,
                 borderRadius: 4,
                 boxShadow: 5,
                 backgroundColor: "#f9f9f9",
               }}
             >
               <CardContent>
                 <Typography variant="h5" fontWeight="bold" gutterBottom>
                   Configure Receipt Prefix and Sequence Number
                 </Typography>
             
                 {/* Preview panel – unchanged */}
                 <Paper
                   elevation={3}
                   sx={{
                     my: 2,
                     p: 2,
                     backgroundColor: "#e0f7fa",
                     textAlign: "center",
                     fontSize: "1.2rem",
                     fontWeight: 600,
                     color: "#00796b",
                   }}
                 >
                   Preview: {receiptPrefix || "____"}-{startSequence || "____"}
                 </Paper>
             
                 {/* Form row */}
                 <Stack
                   direction={{ xs: "column", sm: "row" }}
                   spacing={2}
                   alignItems="center"
                 >
                  <TextField
                     label="Receipt Type"
                     select
                     value={rolePayment}
                     onChange={(e) => setfeeType(e.target.value)}
                     sx={{ flex: 1, minWidth: 150 }}
                     required
                   >
                      <MenuItem value="admission_fee">Admission_Fee Receipt</MenuItem>
                             <MenuItem value="tution_fee">Tution_Fee Receipt</MenuItem>
                             <MenuItem value="bus_fee">Bus_Fee Receipt</MenuItem>
                             <MenuItem value="exam_fee">Exam_Fee Receipt</MenuItem>
                             <MenuItem value="other_fee">Other_Fee Receipt</MenuItem>
                   </TextField>
                   
                   <TextField
                     label="Prefix"
                     value={receiptPrefix}
                     onChange={(e) => setPrefix(e.target.value)}
                     sx={{ flex: 1 }}
                     required
                   />
             
                   <TextField
                     label="Sequence Number"
                     type="number"
                     value={startSequence}
                     onChange={(e) => setSequence(e.target.value)}
                     sx={{ flex: 1 }}
                     required
                   />
             
                   
             
                   <Button
                     variant="contained"
                     color="primary"
                     onClick={handleSubmit}
                     disabled={prefixloading}
                     sx={{ minWidth: 120, minHeight: 45,backgroundColor: "#3C3972",'&:hover': {
                 backgroundColor: "#3C3972", // same as normal
               } }}
                   >
                     {prefixloading ? (
                       <CircularProgress size={24} sx={{ color: "#fff" }} />
                     ) : (
                       "Submit"
                     )}
                   </Button>
                 </Stack>
               </CardContent>
             </Card>
             
            //        ) :selectedMenu === "HallTicket Prefix" ? (
                             
            //   <Card
            //          sx={{
            //            maxWidth: 800,
            //            mx: "auto",
            //            mt: 4,
            //            p: 3,
            //            borderRadius: 4,
            //            boxShadow: 5,
            //            backgroundColor: "#f9f9f9",
            //          }}
            //        >
            //          <CardContent>
            //            <Typography variant="h5" fontWeight="bold" gutterBottom>
            //              Configure Hall-Ticket Prefix
            //            </Typography>
             
            //           {/* Preview Panel */}
                 
             
            //      {/* Explanation Section */}
            //      <Paper
            //        elevation={2}
            //        sx={{
            //          p: 2,
            //          backgroundColor: "#fff3e0",
            //          border: "1px solid #ffc107",
            //          borderRadius: 2,
            //          mb: 3,
            //          mt:1,
            //          width: "95%",
            //          mx: "auto",
            //          fontSize: "0.95rem",
            //          lineHeight: 1.6,
            //        }}
            //      >
            //        <Typography variant="subtitle1" fontWeight="bold" color="#ff9800" gutterBottom>
            //          Hall Ticket Number Format Explanation:
            //        </Typography>
            //        <ul style={{ paddingLeft: "20px", margin: 0 }}>
            //          <li><b>Prefix (5 chars max)</b>: Letters/numbers like <code>HALTC</code></li>
            //          <li><b>Class (2 digits)</b>: e.g., <code>01</code> for Class-I</li>
            //          <li><b>Section (1 letter)</b>: e.g., <code>1</code> for Section-A</li>
            //          <li><b>Roll Number (2 digits)</b>: Unique student number in that class-section (e.g., <code>01</code>)</li>
            //        </ul>
            //        <Typography sx={{ mt: 1 }}>
            //          <b>Example:</b> <code>HALTC01101</code> → <b>Prefix:</b> HALTC, <b>Class:</b> 01, <b>Section:</b> 1, <b>Roll No:</b> 01
            //        </Typography>
            //      </Paper>
            //      <Paper
            //        elevation={3}
            //        sx={{
            //          my: 2,
            //          p: 2,
            //          backgroundColor: "#e0f7fa",
            //          textAlign: "center",
            //          fontSize: "1.2rem",
            //          fontWeight: 600,
            //          color: "#00796b",
            //          width: "80%",
            //          mx: "auto",
            //        }}
            //      >
            //        Preview: {preview}
            //      </Paper>
             
            //            {/* Form row */}
            //            <Stack
            //              // direction={{ xs: "column", sm: "row" }}
            //              spacing={2}
            //              alignItems="center"
                       
            //            >
            //              <TextField
            //                label="Prefix"
            //                value={prefix}
            //                onChange={(e) => {
            //                  const input = e.target.value.toUpperCase();
            //                  if (/^[A-Z0-9]*$/.test(input) && input.length <= 5) {
            //                    setHallTicketPrefix(input);
            //                  }
            //                }}
            //                sx={{ width:'440px'}}
            //                required
            //                size="medium"
            //              />
             
             
            //              <Button
            //                variant="contained"
            //                onClick={handleHallTicketPrefixSubmit}
            //                disabled={hallticketprefixloading}
            //                sx={{
            //                  minWidth: 120,
            //                  minHeight: 45,
            //                  backgroundColor: "#3C3972",
            //                  fontWeight: "bold",
            //                  "&:hover": { backgroundColor: "#3C3972" },
            //                }}
            //              >
            //                {hallticketprefixloading ? (
            //                  <CircularProgress size={24} sx={{ color: "#fff" }} />
            //                ) : (
            //                  "Submit"
            //                )}
            //              </Button>
            //            </Stack>
             
             
             
            //  {/* //BUTTON GENERATION */}
            //  <Box
            //    sx={{
            //      display: "flex",
            //      justifyContent: "center",
            //      mt: 4, // Add top margin for spacing
            //    }}
            //  >
            //    <Stack direction="row" spacing={2} alignItems="center">
            //      {/* Generate button */}
            //      <Button
            //        variant="contained"
            //        color="primary"
            //        onClick={generateHallTickets}
            //        disabled={generating}
            //        sx={{
            //          minWidth: 240,
            //          backgroundColor: "#3C3972",
            //          "&:hover": { backgroundColor: "#3C3972" },
            //        }}
            //      >
            //        {generating ? (
            //          <CircularProgress size={24} sx={{ color: "#fff" }} />
            //        ) : (
            //          "Generate Hall-ticket for All Students"
            //        )}
            //      </Button>
             
            //      {/* Delete button */}
            //      <Button
            //        variant="contained"
            //        color="error"
            //        onClick={deleteHallTickets}
            //        disabled={deleting}
            //        sx={{ minWidth: 240 }}
            //      >
            //        {deleting ? (
            //          <CircularProgress size={24} sx={{ color: "#fff" }} />
            //        ) : (
            //          "Delete Hall-ticket Number for All Students"
            //        )}
            //      </Button>
            //    </Stack>
            //  </Box>
             
             
             
            //          </CardContent>
            //        </Card>
             
             
                   ):(
             
                      <Typography variant="body1" color="text.secondary">
                               This feature is coming soon. Stay tuned!
                             </Typography>
             
                           )}
            
          </Box>
        </Box>
      </Card>

      <ToastContainer  position="top-right"  autoClose={2000} />
    </Box>
  );
};

export default IntermediateSettings;